import React from 'react'
import Manager from '../../public/components/Manager'
import GiveVacationApplyDetail from './GiveVacationApplyDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        { text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <GiveVacationApplyDetail {...props} id={0} />) },
    ],
    export:true,
    exportColumns: [
        { _text: '记录编号', field: 'Number', minWidth: 150 },
        { _datetime: '创建日期', field: 'CreateTime', minWidth: 150 },
        { _text: '部门名称', field: 'Dep', minWidth: 150 },
        { _text: '员工姓名', field: 'PersonName', minWidth: 150 },
        { _text: '假勤项目', field: 'VacationName', minWidth: 150 },
        { _datetime: '开始日期', field: 'StartTime', minWidth: 150 },
        { _text: '备注', field: 'Remark', minWidth: 150 },
        { _text: '充值时长（小时）', field: '_TotalTime', minWidth: 150 },
        { _datetime: '生效日期', field: '_Effective', minWidth: 150 },
        { _datetime: '有效期', field: '_validity', minWidth: 150 },
    ],
    columns: [
        { _text: '记录编号', minWidth: 250, search: true, },
        { _text: '部门名称', minWidth: 150, flex: 10, search: true },
        { _text: '人员姓名', minWidth: 150, search: true, },
        { _text: '假期名称', minWidth: 150, search: true, },
        { _date: '开始时间', minWidth: 150, filter: true, align: 'left'},
        { _text: '创建人', minWidth: 150, search: true, },
        { _datetime: '创建时间', minWidth: 150, filter: true, align: 'left'},
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <GiveVacationApplyDetail {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />